import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApPanelComponent } from '@ap/panel';
import { ApIconLinkComponent } from '@ap/icon-link';
import { ApPhonePipe } from '@ap/formatters';

@Component({
    selector: 'cta',
    templateUrl: './cta.component.html',
    standalone: true,
    imports: [ApAnalyticsModule, ApPanelComponent, ApIconLinkComponent, ApContentModule, FormsModule, ReactiveFormsModule, ApPhonePipe]
})
export class CtaComponent {}
